export const FILTER_TYPES = {
    TEXT: 'text',
    TEXT_ARRAY: 'textarray',
    NUMBER: 'number',
    DATE: 'date',
    CHOICE: 'choice',
    CUSTOM: 'custom'
}

export const FIELD_TYPES = {
    TEXT: 'text',
    DATE: 'date',
    DATE_RANGE: 'daterange',
    DATE_RELATIVE: 'daterelative',
    CHOICE: 'choice',
    NUMBER: 'number',
    CUSTOM: 'custom',
    TEXT_ARRAY: 'textarray',
}